module.exports = __webpack_public_path__ + "static/opportunities.204c2829.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/templates/assets/opportunities.jpg
// module id = 990
// module chunks = 101932004231744